import {Component} from '@angular/core';
import {SkeletonModule} from 'primeng/skeleton';

@Component({
  selector: 'em-skeleton',
  templateUrl: './skeleton.component.html',
  imports: [SkeletonModule],
})
export class SkeletonComponent {}
